<mat-dialog-content>
  <mat-card-title>{{ 'ecase.explorer.documentList.replace.title' | translate }}</mat-card-title>
  <div *ngIf="uploadedFile">
    <span>{{ uploadedFile.name }}</span>
    <button (click)="removeFile()"
            mat-icon-button
            color="accent"
            [attr.aria-label]="'ecase.explorer.documentList.replace.removeFileAriaLabel' | translate">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
  <div *ngIf="!uploadedFile">
    <input #uploader
           id="fileToBeReplaced"
           type="file"
           hidden
           (change)="uploadFile($event)"
           [attr.aria-label]="'ecase.explorer.documentList.replace.fileToUpload' | translate">
    <button mat-raised-button
            (click)="uploader.click()"
            style="margin-top: 5px; margin-bottom: 10px">
      <mat-icon>cloud_upload</mat-icon>
      <span style="padding-left: 5px">{{ 'ecase.explorer.documentList.replace.fileToUpload' | translate }}</span>
    </button>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="eCase-dialog-action-button-align">
    <button class="eCase-dialog-positive-action-button"
            [disabled]="!uploadedFile || submitting"
            mat-raised-button
            (click)="onConfirm()">
      {{ 'ecase.explorer.documentList.replace.title' | translate }}
    </button>
    <button class="eCase-dialog-negative-action-button"
            (click)="onClose()"
            mat-raised-button
            mat-dialog-close>
      {{ 'ecase.common.cancel' | translate }}
    </button>
  </div>
</mat-dialog-actions>
